 <template>
  <div class="left_tab">
    <el-input
      class="input_query"
      :placeholder="$t('lang.请输入')"
      prefix-icon="el-icon-search"
      v-model="levelName"
    >
    </el-input>
    <div class="levelTitle">
      <span>{{ $t("lang.层级列表") }}</span>
      <div @click="onClickOperate(1)">
        <i class="el-icon-circle-plus-outline"></i>
        <span>{{ $t("lang.添加层级") }}</span>
      </div>
    </div>
    <div class="levelList" v-if="levelData.length !== 0">
      <div
        v-for="(item, index) in levelDataCopy"
        :key="index"
        :class="['levelItem', item.rootId == levelActive ? 'active' : '']"
        @click="onClickLevelItem(item.rootId)"
      >
        <span class="overflow">{{ item.rootName }}</span>
        <div>
          <i class="el-icon-edit" @click.stop="onClickOperate(2, item)"></i>
          <i class="el-icon-delete" @click.stop="onClickDelLevel(item)"></i>
        </div>
      </div>
    </div>
    <div v-else class="noData">{{ $t("lang.暂无数据") }}</div>
    <LevelDialog ref="levelDialogRef" />
  </div>
</template>
 
 <script>
import { mapActions } from "vuex";
import LevelDialog from "../dialog/level-dialog.vue";
export default {
  components: { LevelDialog },
  inject: ["equipmentPage"],
  data() {
    return {
      levelName: "",
      /**激活层级 */
      levelActive: 0,
      levelData: [],
      levelDataCopy: [],
    };
  },
  mounted() {},
  created() {
    this.getSimpleLevelList();
  },
  watch: {
    levelName(val) {
      if (val == "") return (this.levelDataCopy = this.levelData);
      this.levelDataCopy = this.levelData.filter(
        (item) => item.rootName.includes(val) == true
      );
    },
  },
  methods: {
    ...mapActions({
      simpleLevelList: "ZD_SimpleLevelList",
      simpleLevelDelete: "ZD_SimpleLevelDelete",
    }),
    onClickLevelItem(rootId) {
      this.levelActive = rootId;
      this.equipmentPage.$refs.rightDeviceRef.getDeviceList(rootId);
    },
    async getSimpleLevelList() {
      let res = await this.simpleLevelList({});
      if (res.success !== 1) return;
      this.levelData = res.listitem;
      this.levelDataCopy = res.listitem;
      if (res.listitem.length > 0) {
        this.levelActive = res.listitem[0].rootId;
        this.equipmentPage.$refs.rightDeviceRef.getDeviceList(
          res.listitem[0].rootId
        );
      }
    },
    /* 操作  1-添加 2-编辑*/
    onClickOperate(type, item) {
      this.$refs.levelDialogRef.dialogShow(type, item);
    },
    onClickDelLevel(item) {
      this.$confirm(
        this.$t("lang.您是否确认删除该层级"),
        this.$t("lang.提示"),
        {
          confirmButtonText: this.$t("lang.确定"),
          cancelButtonText: this.$t("lang.取消"),
          type: "warning",
        }
      )
        .then(async () => {
          let res = await this.simpleLevelDelete({
            value: {
              rootId: item.rootId,
            },
          });
          if (res.success !== 1) return;
          this.$message({
            type: "success",
            message: this.$t("lang.删除成功"),
          });
          /**初始化数据 */
          this.equipmentPage.$refs.rightDeviceRef.totalItemCount = "--";
          this.equipmentPage.$refs.rightDeviceRef.levelData = {};
          this.getSimpleLevelList();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped lang='less'>
.left_tab {
  width: 249px;
  border-right: 1px solid #eeeeee;
  color: #666;
}
.input_query {
  width: 210px;
  margin: 10px 20px 21px 19px;
}
.levelTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px 10px 19px;
  span:first-child {
    font-size: 14px;
    font-weight: bold;
  }
  div {
    font-size: 12px;
    color: #409eff;
    cursor: pointer;
    i {
      vertical-align: middle;
      font-size: 15px;
      margin-right: 4px;
    }
  }
  div:hover {
    color: #66b1ff;
  }
}
.levelList {
  .levelItem {
    height: 36px;
    line-height: 36px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px 0 40px;
    cursor: pointer;
    font-size: 14px;
    i {
      font-size: 14px;
      margin-left: 18px;
    }
  }
  .active {
    background: #6abdf7 !important;
    color: #fff;
  }
  .levelItem:hover {
    background: #d8f3ffe0;
    opacity: 0.9;
  }
}
.noData {
  text-align: center;
  margin-top: 30px;
}
.overflow {
  width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>